import { FC, HTMLInputTypeAttribute, SVGProps, ReactNode, MouseEventHandler, InputHTMLAttributes } from 'react';
import { Control, FieldValues, RegisterOptions, UseFormRegister } from 'react-hook-form';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'color'> {
  id: string;
  onChange?: (value: string) => void;
  type?: HTMLInputTypeAttribute;
  placeholder?: string;
  required?: boolean;
  value?: string | number;
  name?: string;
  color?: ColorType;
  disabled?: boolean;
  readOnly?: boolean;
  rightIcon?: FC<SVGProps<SVGSVGElement>>;
  autoFocus?: boolean;
  helperText?: ReactNode;
  onMouseDown?: MouseEventHandler<HTMLInputElement>;
  rules?: RegisterOptions;
  control?: Control<FieldValues>;
  onClick?: () => void;
  selectedOption?: string;
  borderless?: boolean;
  icon?: FC<React.SVGProps<SVGSVGElement>>;
  bordercolor?: borderColorObjectType;
  hasLeftPadding?: boolean;
  testId?: string;
  inputTestId?: string;
  dropdownTestId?: string;
  isError?: boolean;
  // ReactNode, not just string: PhoneInput forwards its legacy `supportText` here, and that one
  // can be a link element ("this e-mail is already used, log in instead").
  supportText?: string | ReactNode;
  supportTextStyles?: string;
  isFullwidth?: boolean;
  iconStyle?: string;
  rightIconStyle?: string;
  supportTextVariant?: SupportTextVariant;
  label?: string;
  secondaryLabel?: string;
  className?: string;
  /** Additional class names applied to the input's outer wrapper element */
  wrapperStyle?: string;
}

export type SupportTextVariant = 'error' | 'success' | 'default';
export interface FormLabelPropsType {
  label?: ReactNode;
  id?: string;
  children: ReactNode;
  disabled?: boolean;
  isFullWidth?: boolean;
}
export type ColorType = 'success' | 'failure';
export interface IFormValues {
  [x: string]: string;
}
export type RegisterType = UseFormRegister<IFormValues>;
export const borderColorObject = {
  gray: 'border-gray-300 focus:border-primary-300 focus:ring-primary-300 focus-visible:border-primary-300 focus-visible:ring-primary-300',
  primary:
    'border-primary-200 focus:border-primary-300 focus:ring-primary-300 focus-visible:border-primary-300 focus-visible:ring-primary-300',
  'neutral-100':
    'border-neutral-100 focus:border-primary-300 focus:ring-primary-300 focus-visible:border-primary-300 focus-visible:ring-primary-300',
  'neutral-90':
    'border-neutral-90 focus:border-primary-300 focus:ring-primary-300 focus-visible:border-primary-300 focus-visible:ring-primary-300',
};
export type borderColorObjectType = keyof typeof borderColorObject;
